const BASE_URL = "http://localhost:3001/";
const LIVE_URL = `https://notificationapi-zwf4.onrender.com/`;
export const GET_MENU = `${BASE_URL}restaurants/`;
export const SEND_NOTIFICATION = `${LIVE_URL}api/orders/placeOrder`;
